"use client";

import { useState } from "react";

export default function FeedbackButtons({ questionId, onFeedback, feedbackGiven }) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleFeedback = async (helpful) => {
    setIsSubmitting(true);
    await onFeedback(questionId, helpful);
    setIsSubmitting(false);
  };

  return (
    <div className="flex items-center gap-3 mt-4 pt-3 border-t border-gray-200">
      <p className="text-xs text-gray-600 font-medium">Was this helpful?</p>
      <button
        onClick={() => handleFeedback(true)}
        disabled={feedbackGiven || isSubmitting}
        className="inline-flex items-center gap-1 text-xs text-green-600 hover:text-green-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors px-2 py-1 rounded hover:bg-green-50"
      >
        <span className="text-base">👍</span> Yes
      </button>
      <button
        onClick={() => handleFeedback(false)}
        disabled={feedbackGiven || isSubmitting}
        className="inline-flex items-center gap-1 text-xs text-red-600 hover:text-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors px-2 py-1 rounded hover:bg-red-50"
      >
        <span className="text-base">👎</span> No
      </button>
      {feedbackGiven && (
        <span className="text-xs text-gray-500 italic">Thank you for your feedback!</span>
      )}
    </div>
  );
}
